import React, { createContext, useState, ReactNode, useContext } from 'react';

// Definir a interface para o contexto
interface AppContextType {
  refreshAttendances: () => void; // Nova função para atualizar a lista de atendimentos
}

// Criar o contexto com um valor inicial indefinido
const AppContext = createContext<AppContextType | undefined>(undefined);

// Definir a interface para as propriedades do provider
interface AppProviderProps {
  children: ReactNode;
}

// Criar o provider do contexto como função
export function AtendimentoComunication({ children }: AppProviderProps) {
  const [updateFlag, setUpdateFlag] = useState<boolean>(false); // Novo estado para forçar atualização

 
  
  const refreshAttendances = () => {
    setUpdateFlag((prevFlag) => !prevFlag); // Alterar o estado para forçar a atualização
  };

  return (
    <AppContext.Provider value={{refreshAttendances}}>
      {children}
    </AppContext.Provider>
  );
}

// Custom hook para usar o contexto
export const useAppContext = (): AppContextType => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useAppContext must be used within an AtendimentoComunication');
  }
  return context;
};
